// extracted by mini-css-extract-plugin
export default {"primaryButton":"Button_primaryButton__Yx38M","secondaryButton":"Button_secondaryButton__CfKbu"};